export default __webpack_public_path__ + "static/media/trac_5.d1933a64.png";